import React from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { unarchiveCourseMember } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class ActionButtonUnarchive extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  async handleClick() {
    let data = this.props.filters
    data.user_id = this.props.user_id
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage
    try {
      await this.props.unarchiveMember(data)
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Member Unarchived"
            content={`Successfully unarchived course member.`}
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } catch (err) {
      if (err.response.status === 409) {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={
                'This course member has another active course membership and cannot be unarchived. Please contact support@myeducator.com if you need assistance.'
              }
              scheme={Cinnamon.Crisp.SCHEME_RED}
            />
          ),
        })
      } else {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={err.response.data}
              scheme={Cinnamon.Crisp.SCHEME_RED}
            />
          ),
        })
      }
    }
  }

  render() {
    return (
      <div className='text-center'>
        <Button bsSize="xsmall" onClick={this.handleClick}>
          Unarchive
        </Button>
      </div>
    )
  }
}

ActionButtonUnarchive.propTypes = {
  user_id: PropTypes.string,
  unarchiveMember: PropTypes.func,
  filters: PropTypes.object,
}

const mapStateToProp = state => {
  return {
    filters: state.filters,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchiveMemPage: state.currentCourseMemPage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    unarchiveMember: userId => {
      let resp = dispatch(unarchiveCourseMember(userId))
      return resp
    },
  }
}

export default connect(
  mapStateToProp,
  mapDispatchToProps
)(ActionButtonUnarchive)
